import { observable, action, computed } from "mobx";


import { pushDataLayer } from "../helpers/pushDataLayer"

class UserStore {
    constructor(RootStore) {
        this.RootStore = RootStore;
    }

    @observable status = null;
    message = null;

    fetchedUser = { user: { type: "natemat" } };
    currentSlug = null;

    @action('Change store status')
    setStatus = (status, message = null) => {
        this.message = message;
        this.status = status;
    }

    @action("Display User")
    displayUser = user => {
        this.fetchedUser = user;
        this.setStatus("valid");
    };

    @action("Get category based on current URL")
    updateSlug = (slug = "") => {
        if (this.currentSlug !== slug) {
            // prawdopodobnie "wstecz", brak aktualizacji
            this.currentSlug = slug;
            this.setStatus("loading");
        }
        this._fetchFromNetwork(slug, true);
    };

    parseResponse = (res) => {
        pushDataLayer({
            'event': 'virtualPageview',
            'virtualPageURL': `${res.user.url}`,
            'virtualPageTitle': res.user.name,
            'pageType': 'Pozostałe'
        })
        this.RootStore.UIStore.trackPageView({
            page: `${res.user.url}`,
            title: res.user.name
        });

        this.displayUser(res);
        // this._saveToDb(response, slug);
    };

    _fetchFromNetwork = (slug, justUpdate = false) => {
        const that = this;
        const fetchUri = `/pwa-user/${slug}`;
        const fetchUrl = `${window.API_HOST}${fetchUri}`;

        console.log('[ES] fetchUri', fetchUri);

        if (window?.APP_SETTINGS?.pwa_preload && window?.APP_SETTINGS?.pwa_preload[fetchUri]) {
            console.log('[ES] pwa_preload');

            const PWA_userData = window?.APP_SETTINGS?.pwa_preload[fetchUri];
            this.parseResponse(PWA_userData);
            return;
        }

        fetch(fetchUrl)
            .then(response => {
                return response.ok
                    ? response.json()
                    : Promise.reject(response.status);
            })
            .then(res => {
                this.parseResponse(res);
            })
            .catch(err => {
                window.APP_TRACK_ERROR("UserStore-fetchFromNetwork", { url: fetchUrl, error: err });

                if (err === 404) {
                    that.setStatus("error", "Nie znaleziono takiej strony");
                    return;
                } else if (justUpdate) {
                    return;
                } else if (!window.navigator.onLine) {
                    that.setStatus("error", "Brak połączenia z internetem. Nadal możesz korzystać z aplikacji, choć część treści, tak jak ta, będzie niedostępna");
                    return;
                } else {
                    that.setStatus("error", "Ups! Wystąpił problem podczas pobierania strony. Sprawdź połączenie z internetem i spróbuj ponownie");
                    return;
                }
            });
    };
}

export default UserStore;
